import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import {
  IContractMergeExecutionItem,
  IContractMergeExecutionResponse,
  IContractMergeProposalsResponse,
} from 'types/contract/IContractMerge';

/** Asks which of the selected contract days can be merged, and how they group. Changes nothing. */
export const getContractMergeProposalsRequest = async (props: {
  companyId: number;
  contractDateIds: number[];
}): Promise<IContractMergeProposalsResponse> => {
  const { companyId, contractDateIds } = props;
  const response: AxiosResponse<IContractMergeProposalsResponse> = await getApi().post(
    `ContractMerge/Proposals`,
    { contractDateIds },
    { headers: { companyId } },
  );
  return response.data;
};

/** Hands the confirmed merges to the API, which carries them out one after the other and answers once all have an outcome. */
export const mergeContractsRequest = async (props: {
  companyId: number;
  merges: IContractMergeExecutionItem[];
}): Promise<IContractMergeExecutionResponse> => {
  const { companyId, merges } = props;
  const response: AxiosResponse<IContractMergeExecutionResponse> = await getApi().post(
    `ContractMerge/Merge`,
    { merges },
    { headers: { companyId } },
  );
  return response.data;
};
